import { Injectable } from '@angular/core';

const CONFIG_KEY_LANGUAGE = 'language';

export enum Language {
	PT = 0,
	EN = 1
}

export const LANGUAGES = [
	Language.PT,
	Language.EN
];

export const LANGUAGE_ABBREVIATION = {
	[Language.PT]: 'pt',
	[Language.EN]: 'en',
};

export const LANGUAGE_FILE = {
	[Language.PT]: 'assets/i18n/pt.json',
	[Language.EN]: 'assets/i18n/en.json'
};

export const LANGUAGE_IMAGES = {
	[Language.PT]: 'assets/i18n/flags/pt.png',
	[Language.EN]: 'assets/i18n/flags/en.png'
};

@Injectable()
export class TranslationService {

	public _: any = {};

	public language: Language = Language.PT;

	/**
	 * Constructor
	 */
	constructor() {
		this.getLanguage();

		// load i18n
		Object.assign(this._, (window as any).__app_translations[this.language]);
	}

	/**
	 * Get language
	 */
	public getLanguage(): void {
		let language: string | Language | null = localStorage.getItem(CONFIG_KEY_LANGUAGE);

		if (language == null) {
			localStorage.setItem(CONFIG_KEY_LANGUAGE, Language.PT + '');
			language = Language.PT;
		}

		language = Number(language);

		this.language = language;
	}

	/**
	 * Set new language
	 */
	public setLanguage(language: Language): void {
		this._ = null;
		localStorage.setItem(CONFIG_KEY_LANGUAGE, language + '');
		window.location.reload();
	}
}
